import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import Dashboard from './dashboard';
import AccountSetup from './setup';
import PurchaseScreen from './purchases';
import { TAB_ORDER } from './tabs';

// Each dashboard tab is its own URL so a refresh keeps the customer on the same
// screen:
//
//   /account                          → redirects to /account/unassigned
//   /account/unassigned|my-books|gifts → the dashboard, on that tab
//   /account/setup/:journalId          → set up an unassigned book (FMB / GG).
//                                        The journal was created for that book on
//                                        dashboard entry, so it's reused here.
//   /account/certificate/:giftCertificateId
//                                      → edit an existing gift certificate. No
//                                        journal id needed: the record is looked
//                                        up from GET /v3/commerce/gift_certificates.
//   /account/purchase/:journalId?title=&from=
//                                      → buy upgrades/add-ons/pages/copies/
//                                        shipping for that journal in-app. `title`
//                                        is the display name the entry point
//                                        already had on hand (a child's name or a
//                                        gift's recipient); `from` is the tab to
//                                        return to on Back / Done.
const AccountDashboardRoutes = () => {

  return (
    <Switch>
      <Route path="/account/setup/:journalId" component={AccountSetup} />
      <Route path="/account/certificate/:giftCertificateId" component={AccountSetup} />
      <Route path="/account/purchase/:journalId" component={PurchaseScreen} />
      <Route path={`/account/:tab(${TAB_ORDER.join('|')})`} component={Dashboard} />
      <Redirect to="/account/unassigned" />
    </Switch>
  )
};

export default AccountDashboardRoutes;
